import React from "react";
import {Form, Input, InputNumber, Modal} from "antd";
import {FormModalProps} from "../../utils/useFormModal";

function DocumentsClassificationModal(props: FormModalProps) {

    const {form, ...otherProps} = props;

    return (
        <Modal {...otherProps}>
            <Form form={form} layout="vertical">
                <Form.Item label={'Model No.'} name={'model'}
                           rules={[{required: true, message: 'Please input Model No.'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'Commission rate'} name={'commissionRate'}>
                    <InputNumber precision={0} min={0}/>
                </Form.Item>
                <Form.Item label={'Designer'} name={'designer'}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'BU'} name={'bu'}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default DocumentsClassificationModal;
